"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateTaxNumber = exports.FormatTaxNumber = void 0;
function FormatTaxNumber(taxNumber) {
    return taxNumber.replace(/[\ \-]/gi, "");
}
exports.FormatTaxNumber = FormatTaxNumber;
function ValidateTaxNumber(taxNumber) {
    if (typeof taxNumber !== "string")
        return false;
    taxNumber = taxNumber.trim();
    if (taxNumber.length !== 10)
        return false;
    taxNumber = taxNumber.replace(/[\ \-]/gi, "");
    let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    let controlNumber = parseInt(taxNumber.substring(9, 10));
    let weightCount = weight.length;
    for (let i = 0; i < weightCount; i++) {
        sum += parseInt(taxNumber.substr(i, 1)) * weight[i];
    }
    return sum % 11 === controlNumber;
}
exports.ValidateTaxNumber = ValidateTaxNumber;
//# sourceMappingURL=ValidationTaxNumber.js.map